export default __webpack_public_path__ + "static/media/lsp-tuk-3.44376a10.png";